import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { GxpExcursionEvent } from './types';
import { CriticalCircleIcon } from '@/assets/icons/icons';

interface ExcursionEventsTableProps {
  events: GxpExcursionEvent[];
}

const ExcursionEventsTable: React.FC<ExcursionEventsTableProps> = ({
  events,
}) => {
  const getTimezone = (value?: string) =>
    value?.match(/\b([A-Za-z]{2,5}|GMT[+-]\d{1,2}|UTC[+-]\d{1,2})$/)?.[1] ??
    'UTC';

  const startTimezone = getTimezone(events[0]?.start);
  const endTimezone = getTimezone(events[0]?.end);
  const removeTimezone = (value?: string) => {
    if (!value) return '-';
    return value.replace(/\s+[A-Z]{2,5}$/, '');
  };
  const columns: ColumnsType<GxpExcursionEvent> = [
    { title: 'Event', dataIndex: 'event_id', key: 'event_id' },
    { title: 'Sensor', dataIndex: 'sensor_label', key: 'sensor_label' },
    { title: 'Phase', dataIndex: 'phase_label', key: 'phase_label' },
    {
      title: `Start (${startTimezone})`,
      dataIndex: 'start',
      key: 'start',
      width: 140,
      render: (value: string) => removeTimezone(value),
    },
    {
      title: `End (${endTimezone})`,
      dataIndex: 'end',
      key: 'end',
      width: 140,
      render: (value: string) => removeTimezone(value),
    },
    { title: 'Duration', dataIndex: 'duration_label', key: 'duration_label' },
    {
      title: 'Peak',
      dataIndex: 'peak',
      key: 'peak',
      render: (value: number) => (
        <span className='gxp-table-cell--danger'>{value}°C</span>
      ),
    },
    {
      title: '°C min',
      dataIndex: 'degmin',
      key: 'degmin',
      render: (value: number) => (
        <span className='gxp-table-cell--danger'>{value}</span>
      ),
    },
    {
      title: 'Type',
      dataIndex: 'type_label',
      key: 'type_label',
      render: (_, record) => {
        return (
          <span className='gxp-status-tag gxp-status-tag--danger'>
            <CriticalCircleIcon width={12} height={12} />
            {record?.type_label}
          </span>
        );
      },
    },
  ];
  return (
    <div className='gxp-card'>
      <div className='gxp-card__title'>Excursion events</div>
      {events.length === 0 ? (
        <div className='gxp-empty-text'>
          No excursions. The sensor stayed in range for the full window.
        </div>
      ) : (
        <div className='settings-content-wrapper'>
          <Table
            className='gxp-table settings-table'
            columns={columns}
            dataSource={events}
            rowKey={(event) =>
              `${event.sensor_tracking_id ?? ''}-${event.event_id ?? ''}`
            }
            pagination={false}
            scroll={{ x: true }}
          />
        </div>
      )}
    </div>
  );
};

export default ExcursionEventsTable;
